// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/builds/desertaxle/bulletn-landing-page/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/builds/desertaxle/bulletn-landing-page/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-login-js": () => import("/builds/desertaxle/bulletn-landing-page/src/pages/login.js" /* webpackChunkName: "component---src-pages-login-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/builds/desertaxle/bulletn-landing-page/.cache/data.json")

